import axios from 'axios'
import { logout, refreshTokens } from 'auth'

axios.defaults.headers.common['Content-Type'] = 'application/json'
// axios.defaults.headers.get['Pragma'] = 'no-cache'
// axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
axios.defaults.maxContentLength = 100000000
axios.defaults.baseURL = 'https://api.sikaisanjal.com'
// axios.defaults.baseURL = 'http://7825-2400-1a00-b050-4c8c-fced-edb8-4186-91b7.ngrok.io'

// Inject store value (to access auth token)
let store
export const injectStore = (_store) => {
  store = _store
}

axios.interceptors.request.use((config) => {
  const auth = store.getState().auth
  const isAuthorized = auth.isAuthenticated && auth.authToken
  if (isAuthorized) {
    config.headers['Authorization'] = `Bearer ${auth.authToken}`
  }
  return config
})

axios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (axios.isCancel(error)) {
      throw new axios.Cancel('Operation canceled by the user.')
    }
    if (error?.response) {
      const auth = store.getState().auth
      
      if (auth?.authToken) {
        if (error?.response?.status === 401) {
          logout()
          return
        }

      }
    }
    return Promise.reject(error)
   }
)

export default axios
